import {
  GATEWAY_ADD_MONEY_FEES_ERROR,
  GATEWAY_ADD_MONEY_FEES_START,
  GATEWAY_ADD_MONEY_FEES_SUCCESS,
  GATEWAY_ADD_MONEY_FEES_CLEAR,
} from 'constants/action-types/addMoney/addMoneyFromMobileOperator';

export default (state, { type, payload }) => {
  switch (type) {
    case GATEWAY_ADD_MONEY_FEES_START:
      return {
        ...state,
        gatewayAddMoneyFees: {
          ...state.gatewayAddMoneyFees,
          loading: true,
          error: null,
        },
      };
    case GATEWAY_ADD_MONEY_FEES_ERROR:
      return {
        ...state,
        gatewayAddMoneyFees: {
          ...state.gatewayAddMoneyFees,
          error: payload,
          loading: false,
        },
      };
    case GATEWAY_ADD_MONEY_FEES_SUCCESS:
      return {
        ...state,
        gatewayAddMoneyFees: {
          ...state.gatewayAddMoneyFees,
          error: null,
          loading: false,
          data: payload,
        },
      };
    case GATEWAY_ADD_MONEY_FEES_CLEAR:
      return {
        ...state,
        gatewayAddMoneyFees: {
          ...state.gatewayAddMoneyFees,
          error: null,
          loading: false,
          data: null,
        },
      };
    default:
      return null;
  }
};
